import type { FC } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import GridErrorBoundaryFallback from './GridErrorBoundaryFallback';
import AccountForm from './AccountForm';

const AddAccount: FC = () => {
  return (
    <ErrorBoundary FallbackComponent={GridErrorBoundaryFallback}>
      <AccountForm />
    </ErrorBoundary>
  );
};

export default AddAccount;
